import PropTypes from 'prop-types';
import colorsPropTypes from '../utils/colors';
import deprecatedProp from '../utils/deprecated_prop';
var propTypes = {
  ['aria-label']: PropTypes.string,
  ['aria-labelledby']: PropTypes.string,
  ['aria-describedby']: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOfType([PropTypes.oneOf(colorsPropTypes), PropTypes.string]),
  customStyle: PropTypes.any,
  disabled: PropTypes.bool,
  flippable: PropTypes.bool,
  focusable: deprecatedProp(PropTypes.bool, 'To make a CustomImage focusable, wrap it in a interactive element that suits the context needs.'),
  quietArea: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  src: PropTypes.string,
  title: deprecatedProp(PropTypes.string, 'To take advantage of the new accessibility features of CustomImage, please consider using `aria-label` for svg and `alt` for img instead.'),
  viewBox: PropTypes.string
};
export default propTypes;